import { useEffect } from 'react';
import { bool } from 'prop-types';
import initialize from './entrypoints/sportsbook';
const AppContainer = ({ dev = false }) => {
    useEffect(() => {
        if (dev) {
            import('./entrypoints/demo');
        }
        else {
            initialize();
        }
    }, []);
    return null;
};
AppContainer.propTypes = {
    dev: bool,
};
export default AppContainer;
//# sourceMappingURL=index.js.map